import React from "react";
import { Box } from "@mui/material";
import { MRT_ColumnDef } from "material-react-table";

import { formatToUSNumber, getFormattedDate } from "utils";
import { RenewableEnergyPurchasesDTO } from "api";

const CellWrapper = ({ children }: { children: React.ReactNode }) => (
  <Box
    sx={{
      display: "flex",
      alignItems: "center",
    }}
  >
    <p
      style={{
        fontFamily: "Inter",
        fontWeight: "400",
        fontSize: "14px",
        margin: 0,
      }}
    >
      {children}
    </p>
  </Box>
);

export const RENEWABLE_ENERGY_PURCHASES_COLUMNS: MRT_ColumnDef<RenewableEnergyPurchasesDTO>[] =
  [
    {
      header: "Geography",
      accessorKey: "geography",
      Cell: ({ row }: { row: any }) => (
        <CellWrapper>{row.original.geography}</CellWrapper>
      ),
      size: 120,
    },
    {
      header: "Total Renewable Energy Amount",
      accessorKey: "totalRenewableEnergy",
      Cell: ({ row }: { row: any }) => (
        <CellWrapper>
          {formatToUSNumber(row.original.totalRenewableEnergy)}{" "}
          {row.original.renewableEnergyUnit}
        </CellWrapper>
      ),
      size: 240,
    },
    {
      header: "Start Date",
      accessorKey: "startDate",
      Cell: ({ row }: { row: any }) => (
        <CellWrapper>
          {getFormattedDate(row.original.startDate, "/")}
        </CellWrapper>
      ),
      size: 120,
    },
    {
      header: "End Date",
      accessorKey: "endDate",
      Cell: ({ row }: { row: any }) => (
        <CellWrapper>{getFormattedDate(row.original.endDate, "/")}</CellWrapper>
      ),
      size: 120,
    },
  ];
